import { Container, Sprite, Text, TextStyle } from "pixi.js";
import { MyBuildingsResourcePackage } from "../resources/MyBuildingsResourcePackage";
import { GameFont } from "../../../common/GameFont";

export class NextBuilding extends Container {
    private static readonly NEXT_BUILDING_HEADER_TEXT = "YOUR NEXT BUILDING GOES HERE";

    private readonly myBuildingsResources: MyBuildingsResourcePackage;
    private readonly referenceWidth: number;

    public constructor(myBuildingsResources: MyBuildingsResourcePackage, width: number) {
        super();
        this.myBuildingsResources = myBuildingsResources;
        this.referenceWidth = width;
        this.build();
    }

    private build(): void {
        const nextBuildingHeader = new Text(NextBuilding.NEXT_BUILDING_HEADER_TEXT, new NextBuildingTextStyle());
        nextBuildingHeader.position.set((this.referenceWidth - nextBuildingHeader.width) * 0.5, 0);
        this.addChild(nextBuildingHeader);

        const nextBuildingView = new Sprite(this.myBuildingsResources.assets_views_mybuildings_ui_next_building_png);
        nextBuildingView.position.set((this.referenceWidth - nextBuildingView.width) * 0.5, nextBuildingHeader.position.y + nextBuildingHeader.height + 10);
        this.addChild(nextBuildingView);
    }
}

class NextBuildingTextStyle extends TextStyle {
    public constructor() {
        super(new TextStyle({
            align: "center",
            fill: "#a1a0a0",
            fontFamily: GameFont.DEFAULT_FONT,
            fontSize: 44,
            lineHeight: 53
        }));
    }
}